module.exports = __webpack_public_path__ + "img/logo.985b65dd.png";